/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InVersion: core.serialization.ObjectSchema<serializers.InVersion.Raw, Truvity.InVersion> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace InVersion {
    export interface Raw {
        values: number[];
    }
}
